import { usePrincipal } from '../../../application/authentication'
import { usePolicy } from '../../../application/product/policy/PolicyProvider'
import { isRenewalPolicy } from '../../../domain'

export const useIsMtaAllowed = () => {
  const { isAdmin } = usePrincipal()
  const { policy } = usePolicy()

  return isAdmin || !isRenewalPolicy(policy)
}
